import { render, staticRenderFns } from "./ClassificationsForm.vue?vue&type=template&id=41569bd8&scoped=true&lang=pug&"
import script from "./ClassificationsForm.vue?vue&type=script&lang=js&"
export * from "./ClassificationsForm.vue?vue&type=script&lang=js&"
import style0 from "./ClassificationsForm.vue?vue&type=style&index=0&id=41569bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41569bd8",
  null
  
)

export default component.exports